import ButtonWithLoader from "../../../../../../common/components/ui/loading/ButtonLoading";
import { useToastContext } from '../../../../../../common/components/ui/toast/toast.context';
import { useMemo, useState } from "react";
import { FormCaucao, createAssasSubscription } from "../../../../services/integration.api";
import { FaCheckCircle } from "react-icons/fa";

type FormPropsCreateRenter = {
  onSave: (vehicleId: string) => void
  depositData: Partial<FormCaucao>
  disabled?: boolean
};

export default function AssasActivate(props: FormPropsCreateRenter) {
  const { notifySuccess, notifyError } = useToastContext()
  const [bindAssasInProgress, setBindAssasInProgress] = useState(false)
  const [buttonColor, setButtonColor] = useState<string>('text-redPrimary');

  async function handleApproveAssas() {
    try {
      setBindAssasInProgress(true)
      const approveRenterProps = props.depositData;
      const result = await createAssasSubscription(approveRenterProps)

      if (!result.ok) {
        notifyError((result as { message?: string })?.message || "Erro ao gerar cobrança no Assas")
        return
      }

      notifySuccess("Cobranças no Assas geradas com sucesso!")
      setButtonColor('success')
    } catch (err) {
      console.log(err)
    } finally {
      setBindAssasInProgress(false)
    }
  }
  const badgeColor = useMemo(() =>
    (buttonColor == "success")
      ? 'text-greenPrimary'
      : 'text-gray'
    , [buttonColor])

  return (
    <div className="grid-class">
      <div>
        <h2 className="font-semibold ">Clique aqui para gerar cobrança no Assas:</h2>
      </div>
      <div className="grid-div2">
        <ButtonWithLoader
          type="button"
          disabled={props.disabled || bindAssasInProgress}
          isLoading={bindAssasInProgress} onClick={handleApproveAssas}>
          Assas
        </ButtonWithLoader>
        <FaCheckCircle size={24} className={`${badgeColor}`} />
      </div>
    </div>

  )
}
